import React, { Component } from 'react';
import scrollReveal from 'scrollreveal';
import User from '../services/User.js';

import '../../css/Home.css';

class Home extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
    }

    window.sr = new scrollReveal();
    
  }

  render() {

    if (this.props.location.pathname.indexOf('about') === -1) {
      let loggedIn = User.isLoggedIn();

      if (loggedIn) {
        this.props.history.push(`/users/${User.getId()}`);
        return null;
      }
    }

    let currentYear = new Date().getFullYear();

    return (
      <div id="homepage">


        <div className="socialMedia">

          <a href="http://twitter.com/SpicyMochaMusic" target="_blank" title="Twitter" className="socialicon">
            <i className="fontastic icon-twitter clickable"></i>
          </a> 

          <a href="http://www.facebook.com/SpicyMochaMusic" target="_blank" title="Facebook" className="socialicon">
            <i className="fontastic icon-facebook clickable"></i>
          </a>

        </div>


        <div className="main-header">

          <h1>Music discovery for those who can't get enough.</h1>

          <p className="lead">Ever had trouble finding a new band?</p>
                
        </div>

        <div className="screenshot">
          <img src="img/similarity_map.png" alt=""/>
        </div>
           
        <div>

          <section className="library">
            <div className="row">
              <div className="right-side" data-sr="enter right">
                  <h2><i className="fontastic icon-library"></i>Visually explore your music library</h2>
                  <h3>Empower yourself</h3>
                  <p>Who knows better what you like listening to? You! </p>
                  <h3>Don't know where to start?</h3>
                  <p>Let yourself deep dive into your own music habits and use that as a starting point</p>
                  <h3>Explore similarity maps</h3>
                  <p>With the aid of maps and inumerous search and filter features you quickly find something suitable for your tastes</p>
              </div>
              <div className="section-image left-side" data-sr="enter left 50px">
                <img src="img/theme_river.png" alt=""/>
                <img src="img/treemap.png" alt=""/>
              </div>
            </div>
          </section>

          <section className="discovery">
            <div className="row">
              <div className="left-side" data-sr="enter left">
                <h2><i className="fontastic icon-new"></i>Discovery at the core</h2>
                <h3>Never lose track of your discoveries</h3>
                <p>It easily lets you mark artists as discovered</p>
                <h3>Suggestions</h3>
                  <p>Can't be bothered looking for artists you might like? No worry. It will generate lots of suggestions based on your listening history.</p>
              </div>
              <div className="section-image right-side" data-sr="enter right ease 50px">
                  <img src="img/discovered_artists.png" alt=""/>
              </div>
            </div>
          </section>

          <section className="radio">
            <div className="row">
              <div className="right-side" data-sr="enter right">
                <h2><i className="fontastic icon-play"></i>Play music</h2>
                <h3>Yes, yes, it's also a radio</h3>
                <p>It's integrated with a variety of music players such as Youtube, Vimeo and Soundcloud</p>
                <h3>Dynamic Playlists</h3>
                <p>Don't listen to the same artist over and over. Pick multiple artists and give them a go.</p>
              </div>
              <div className="section-image left-side" data-sr="enter left">
                <img src="img/youtube_player.png" alt=""/>
              </div>
            </div>
          </section>


          <div className="ask-on-twitter">
            <h1>Got a question for Spicy Mocha?</h1>

            <a href="https://twitter.com/spicymochamusic" className="btn btn-default btn-twitter btn-lg" target="_blank">Ask me on Twitter</a>
          </div>

          <footer>

            <hr/>

            <div className="row">
              <p> 
                Spicy Mocha &middot; { currentYear }
                <br/>
                Made with <span className="footer-hearts">&#10084;</span> in Berlin, Germany
              </p>
              <p>
                  <a href="https://twitter.com/amorimdecoelho" target="_blank"><span className="footer-twitter">@amorimdecoelho</span></a>
              </p>
            </div>
            <div className="text-right footer-right">

              <div className="social text-right">
                <a href="http://twitter.com/SpicyMochaMusic" target="_blank" title="Twitter" className="socialicon"><i className="fontastic icon-twitter clickable"></i></a> 

                <a href="http://www.facebook.com/SpicyMochaMusic" target="_blank" title="Facebook"
              className="socialicon"><i className="fontastic icon-facebook clickable"></i></a>
              </div>
                
            </div>

            <div className="row" id="donation">
              <div className="">
                <div>
                  <p>
                    If you like the idea and enjoy discovering new artists here, please help me maintain the server active.
                    <br/>
                    All donations are welcome. Thank you!
                    <a target="_blank" href="https://paypal.me/amorimdecoelho" className="button">
                      <i className="fontastic icon-paypal"></i>
                    Donate
                    </a>
                  </p>
                </div>
              </div>
            </div>


            <div className="row">
              <p className="powered-by">Powered by:</p>
              <ul className="powered-by">
                <a target="_blank" href="http://www.last.fm"><strong><i className="fontastic large icon-lastfm"></i></strong></a> 
                <a target="_blank" href="http://www.spotify.com"><strong><i className="fontastic large icon-spotify"></i></strong></a>
                <a target="_blank" href="http://www.youtube.com"><strong><i className="fontastic large icon-youtube"></i></strong></a>
                <a target="_blank" href="https://wiki.musicbrainz.org"><strong><i className="fontastic large musicbrainz"></i></strong></a> 
                <a target="_blank" href="https://www.discogs.com"><strong><i className="fontastic large discogs"></i></strong></a>
                <a target="_blank" href="http://www.songkick.com"><strong><i className="fontastic large icon-songkick"></i></strong></a> 
                <a target="_blank" href="https://www.billboard.com"><strong><i className="fontastic large icon-billboard"></i></strong></a> 
                <a target="_blank" href="https://www.vagalume.com.br"><strong><i className="fontastic large vagalume"></i></strong></a>
                <a target="_blank" href="http://www.twitter.com"><strong><i className="fontastic large icon-twitter"></i></strong></a>
                <a target="_blank" href="http://www.facebook.com"><strong><i className="fontastic large icon-facebook"></i></strong></a>
              </ul>
            </div>

          </footer>     


        </div>


      </div>
    );
  }

}

export default Home;



// WEBPACK FOOTER //
// ./src/js/components/Home.jsx